import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchQueue } from "./api";
import type { QueueStateResponse } from "./api";

// Org-scoped запрос (см. `src/query/scope.ts`). Polling-каждые-2-сек
// как useTasks — синхронно подсвечиваем активную задачу.
const POLL_INTERVAL_MS = 2000;

export function useQueue(): UseQueryResult<QueueStateResponse, Error> {
  return useOrgScopedQuery<QueueStateResponse>({
    key: ["queue"],
    queryFn: () => fetchQueue(),
    refetchInterval: POLL_INTERVAL_MS,
    retry: false,
  });
}
